import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, ScanLine, QrCode } from 'lucide-react';
import { RouteTransitionLogo } from '../../components/RouteTransitionLogo';

const FONT = "'Inria Serif', serif";

const resolveProfilePath = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.role === 'venue_owner') return '/venue/profile';
    if (user.role === 'staff') {
      return user.staff_role === 'admin' ? '/staff-admin/profile' : '/staff-app/profile';
    }
    if (user.role === 'admin') return '/admin/profile';
  } catch (_) { /* ignore */ }
  return '/';
};

export default function DemoHubPage() {
  const navigate = useNavigate();

  return (
    <div className="app-shell" data-testid="demo-hub-page" style={{ minHeight: '100vh', backgroundColor: 'var(--app-bg)', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 'calc(env(safe-area-inset-top, 0px) + 56px)', paddingLeft: 24, paddingRight: 24, paddingBottom: 60, position: 'relative' }}>
      <button
        type="button"
        onClick={() => navigate(resolveProfilePath())}
        aria-label="Close demo"
        data-testid="demo-hub-close"
        style={{ position: 'absolute', top: 'max(14px, env(safe-area-inset-top))', right: 18, width: 40, height: 40, borderRadius: '50%', background: 'var(--surface)', border: '1px solid var(--card-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 2 }}
      >
        <X size={20} color="var(--text)" />
      </button>

      <div style={{ marginTop: 8 }}>
        <RouteTransitionLogo width={110} height={98} dataTestId="demo-hub-logo" />
      </div>

      <h1 style={{ fontFamily: FONT, fontSize: 24, fontWeight: 700, color: 'var(--text)', textAlign: 'center', marginTop: 20, marginBottom: 6 }}>Demo QR payment</h1>
      <p style={{ fontFamily: FONT, fontSize: 14, color: 'var(--text-2)', textAlign: 'center', maxWidth: 300, margin: 0, lineHeight: 1.5 }}>
        Practice a full QR payment with your staff — nobody is charged. Pick your role.
      </p>

      <div style={{ marginTop: 36, width: '100%', maxWidth: 360, display: 'flex', flexDirection: 'column', gap: 14 }}>
        <button
          type="button"
          data-testid="demo-hub-test-scan-btn"
          onClick={() => navigate('/demo-scan/scan')}
          style={{ background: 'var(--surface)', border: '1px solid var(--card-border)', borderRadius: 20, padding: '20px', textAlign: 'left', display: 'flex', gap: 14, alignItems: 'center', cursor: 'pointer', boxShadow: '0 4px 12px rgba(0,0,0,0.04)' }}
        >
          <span style={{ width: 48, height: 48, borderRadius: 14, background: 'var(--accent-surface)', color: 'var(--accent-purple)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <ScanLine size={22} />
          </span>
          <span style={{ flex: 1 }}>
            <p style={{ margin: 0, fontFamily: FONT, fontSize: 17, fontWeight: 700, color: 'var(--text)' }}>Test scan</p>
            <p style={{ margin: '2px 0 0', fontFamily: FONT, fontSize: 13, color: 'var(--text-2)' }}>Play the venue — enter a bill and scan the demo QR.</p>
          </span>
        </button>

        <button
          type="button"
          data-testid="demo-hub-demo-qr-btn"
          onClick={() => navigate('/demo-scan/qr')}
          style={{ background: 'var(--surface)', border: '1px solid var(--card-border)', borderRadius: 20, padding: '20px', textAlign: 'left', display: 'flex', gap: 14, alignItems: 'center', cursor: 'pointer', boxShadow: '0 4px 12px rgba(0,0,0,0.04)' }}
        >
          <span style={{ width: 48, height: 48, borderRadius: 14, background: 'rgba(31, 142, 42, 0.12)', color: '#1F8E2A', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <QrCode size={22} />
          </span>
          <span style={{ flex: 1 }}>
            <p style={{ margin: 0, fontFamily: FONT, fontSize: 17, fontWeight: 700, color: 'var(--text)' }}>Demo QR code</p>
            <p style={{ margin: '2px 0 0', fontFamily: FONT, fontSize: 13, color: 'var(--text-2)' }}>Play the guest — show your QR so another phone can scan it.</p>
          </span>
        </button>
      </div>

      <p style={{ marginTop: 'auto', paddingTop: 36, fontFamily: FONT, fontSize: 12, color: 'var(--text-3)', textAlign: 'center' }}>
        Demo mode · No real payment is processed.
      </p>
    </div>
  );
}
